import { call, all, put, takeLatest, fork, delay } from 'redux-saga/effects';
import {
    createLeadSuccess,
    createLeadFailure,
    editLeadSuccess,
    editLeadFailure,
    editLeadAllSuccess,
    editLeadAllFailure
} from './actions';
import { createLeadAPI, deleteLeadAPI, editLeadAPI } from '../../helpers/fakebackend_helper';
import { CREATE_LEAD_REQUEST, DELETE_LEAD_FAILURE, DELETE_LEAD_REQUEST, DELETE_LEAD_SUCCESS, EDIT_LEAD_ALL_REQUEST, EDIT_LEAD_REQUEST } from './actionsType';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function* createLeadSaga(action) {
    try {
        const { leadData, navigate } = action.payload;
        const response = yield call(createLeadAPI, leadData);
        if (response && response.success === true) {
            toast.success(response.message, { autoClose: 1000 });
            yield put(createLeadSuccess(response));
            yield delay(2000);
            navigate('/leads');
        }
    } catch (error) {
        toast.error(error.response.data.message, { autoClose: 1000 });
        yield put(createLeadFailure(error.response.data));
    }
}


function* deleteLeadSaga({ payload: data }) {
    try {
        const response = yield call(deleteLeadAPI, { data });
        toast.success(response.message, { autoClose: 1000 });
        yield put({
            type: DELETE_LEAD_SUCCESS,
            payload: response
        });

    } catch (error) {
        toast.error(error.response.data.message, { autoClose: 1000 });
        yield put({
            type: DELETE_LEAD_FAILURE,
            payload: error.message
        });

    }
}


function* editLeadSaga(action) {
    try {
        const { leadData, navigate } = action.payload;
        const response = yield call(editLeadAPI, leadData);
        toast.success(response.message, { autoClose: 1000 });
        yield put(editLeadSuccess(response.data));
        yield delay(2000);
        navigate('/leads');
    } catch (error) {
        toast.error(error.response.data.message, { autoClose: 1000 });
        yield put(editLeadFailure(error.message));
    }
}


function* editAllLeadSaga(action) {
    try {
        const { leadData } = action.payload;
        const response = yield call(editLeadAPI, leadData);
        toast.success(response.message, { autoClose: 1000 });
        yield put(editLeadAllSuccess(response.data));
    } catch (error) {
        toast.error(error.response.data.message, { autoClose: 1000 });
        yield put(editLeadAllFailure(error.message));
    }
}


export function* watchleadSagas() {
    yield takeLatest(CREATE_LEAD_REQUEST, createLeadSaga);
}

export function* watchDeleteLead() {
    yield takeLatest(DELETE_LEAD_REQUEST, deleteLeadSaga);
}

export function* watchEditLead() {
    yield takeLatest(EDIT_LEAD_REQUEST, editLeadSaga);
}

export function* watchEditAllLead() {
    yield takeLatest(EDIT_LEAD_ALL_REQUEST, editAllLeadSaga);
}


function* authLeadSaga() {
    yield all([
        fork(watchleadSagas),
        fork(watchDeleteLead),
        fork(watchEditLead),
        fork(watchEditAllLead)
    ])
}

export default authLeadSaga;